import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";

import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import SitePauseBanner from '../Components/Common/SitePauseBanner';
import VillageSystemNoticeModal from '../Components/Common/VillageSystemNoticeModal';
import { useAuthContext } from '../Components/AuthContext';
import { SITE_ID } from '../assets/meta/meta';
import {
    dismissVillageSystemNotice,
    shouldShowVillageSystemNotice,
} from '../common/villageSystemNotice';

import { useLayoutStore } from "../store/useLayoutStore";


const Layout = (props) => {

    const { userInfo } = useAuthContext();
    const [isVillageSystemNoticeOpen, setIsVillageSystemNoticeOpen] = useState(() => (
        shouldShowVillageSystemNotice({ siteId: SITE_ID, userId: userInfo?.id })
    ));

    const layoutType = useLayoutStore(state => state.layoutType);
    const leftSidebarType = useLayoutStore(state => state.leftSidebarType);
    const layoutModeType = useLayoutStore(state => state.layoutModeType);
    const layoutWidthType = useLayoutStore(state => state.layoutWidthType);
    const layoutPositionType = useLayoutStore(state => state.layoutPositionType);
    const topbarThemeType = useLayoutStore(state => state.topbarThemeType);
    const leftsidbarSizeType = useLayoutStore(state => state.leftsidbarSizeType);
    const leftSidebarViewType = useLayoutStore(state => state.leftSidebarViewType);
    const leftSidebarImageType = useLayoutStore(state => state.leftSidebarImageType);

    const changeLayout = useLayoutStore(state => state.changeLayout);
    const changeSidebarTheme = useLayoutStore(state => state.changeSidebarTheme);
    const changeLayoutMode = useLayoutStore(state => state.changeLayoutMode);
    const changeLayoutWidth = useLayoutStore(state => state.changeLayoutWidth);
    const changeLayoutPosition = useLayoutStore(state => state.changeLayoutPosition);
    const changeTopbarTheme = useLayoutStore(state => state.changeTopbarTheme);
    const changeLeftsidebarSizeType = useLayoutStore(state => state.changeLeftsidebarSizeType);
    const changeLeftsidebarViewType = useLayoutStore(state => state.changeLeftsidebarViewType);
    const changeSidebarImageType = useLayoutStore(state => state.changeSidebarImageType);

    useEffect(() => {
        if (
            layoutType ||
            leftSidebarType ||
            layoutModeType ||
            layoutWidthType ||
            layoutPositionType ||
            topbarThemeType ||
            leftsidbarSizeType ||
            leftSidebarViewType ||
            leftSidebarImageType
            ) {
            changeLeftsidebarViewType(leftSidebarViewType);
            changeLeftsidebarSizeType(leftsidbarSizeType);
            changeSidebarTheme(leftSidebarType);
            changeLayoutMode(layoutModeType);
            changeLayoutWidth(layoutWidthType);
            changeLayoutPosition(layoutPositionType);
            changeTopbarTheme(topbarThemeType);
            changeLayout(layoutType);
            changeSidebarImageType(leftSidebarImageType);
        }
    }, [layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        changeLayout,
        changeSidebarTheme,
        changeLayoutMode,
        changeLayoutWidth,
        changeLayoutPosition,
        changeTopbarTheme,
        changeLeftsidebarSizeType,
        changeLeftsidebarViewType,
        changeSidebarImageType]);
    const onChangeLayoutMode = (value) => {
        if (changeLayoutMode) {
            changeLayoutMode(value);
        }
    };

    const onToggleSidebar = () => {
        const windowSize = document.documentElement.clientWidth;
        const currentSize = document.documentElement.getAttribute('data-sidebar-size') || leftsidbarSizeType;

        if (layoutType !== 'vertical' && document.documentElement.getAttribute('data-layout') !== 'vertical') {
            return;
        }

        if (windowSize <= 767) {
            document.body.classList.toggle('vertical-sidebar-enable');
            changeLeftsidebarSizeType('lg');
            return;
        }

        document.body.classList.remove('vertical-sidebar-enable');

        if (windowSize < 1025) {
            changeLeftsidebarSizeType(currentSize === 'sm' ? 'lg' : 'sm');
            return;
        }

        changeLeftsidebarSizeType(currentSize === 'lg' ? 'sm' : 'lg');
    };

    const [headerClass, setHeaderClass] = useState("");
    // class add remove in header
    useEffect(() => {
        window.addEventListener("scroll", scrollNavigation, true);
    });
    function scrollNavigation() {
        var scrollup = document.documentElement.scrollTop;
        if (scrollup > 50) {
            setHeaderClass("topbar-shadow");
        } else {
            setHeaderClass("");
        }
    }

    const confirmVillageSystemNotice = () => {
        dismissVillageSystemNotice({ siteId: SITE_ID, userId: userInfo?.id });
        setIsVillageSystemNoticeOpen(false);
    };

    return (
        <React.Fragment>
            <VillageSystemNoticeModal
                isOpen={isVillageSystemNoticeOpen}
                onConfirm={confirmVillageSystemNotice}
            />
            <div id="layout-wrapper">
                <Header
                    headerClass={headerClass}
                    layoutModeType={layoutModeType}
                    onChangeLayoutMode={onChangeLayoutMode}
                    onToggleSidebar={onToggleSidebar} />
                <Sidebar onToggleSidebar={onToggleSidebar} />
                <main className="main-content">
                    <SitePauseBanner />
                    {props.children}
                    <Footer />
                </main>
            </div>
        </React.Fragment>

    );
};

Layout.propTypes = {
    children: PropTypes.object,
};

export default Layout;
